<template>
  <v-container class="shopStartPage"
               ref="startPage"
               id="shopStartPage"
  >
    <v-snackbar class="notificationSnackbar"
                :value="this.getShowNotification"
                :timeout="timeoutDuration"
                bottom
    >
      <span>{{ this.getNotificationTxt }}</span>
    </v-snackbar>

    <side-navigation/>

    <inventory-drawer/>

    <mhd-inventory-drawer v-if="getCurrentActiveMode && getCurrentActiveMode === 'mhd'"/>

    <cart-drawer/>

    <transition
        name="fade"
        mode="out-in"
    >
    <router-view/>
    </transition>

    <scanner-dialog/>

    <portal-target v-if="!getInventoryMode && !getCurrentActiveMode" name="addCart"/>
    <portal-target v-if="getInventoryMode&& !getCurrentActiveMode" name="addInventory"/>
    <portal-target v-if="getCurrentActiveMode && getCurrentActiveMode === 'mhd'" name="addToMHDList"/>
    <!--<portal-target name="addLabel"/>-->

  </v-container>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";
import SideNavigation from "@/app/global/sideNavigation";
import CartDrawer from "@/app/cart/cartDrawer";
import ScannerDialog from "@/app/scanner/scannerDialog";
import InventoryDrawer from "@/app/inventory/inventoryDrawer";
import MhdInventoryDrawer from "@/app/mhdinventory/mhdInventoryDrawer.vue";
export default {
  name: "Shop",
  components: {MhdInventoryDrawer, InventoryDrawer, ScannerDialog, CartDrawer, SideNavigation},

  data:() => {
    return {
      timeoutDuration: 3000,
    }
  },

  methods: {
    ...mapMutations({
      setShowNotification: 'setShowNotification'
    }),
  },

  computed: {
    ...mapGetters({
      overlayVisible: 'getOverlayVisibility',
      getCartContentVisibility: 'getCartContentVisibility',
      getScannerVisibility: 'getScannerVisibility',
      getShowNotification: 'getShowNotification',
      getNotificationTxt: 'getNotificationTxt',
      getCurrentActiveMode: 'getCurrentActiveMode'
    }),

    ...mapGetters('inventory', {
      getInventoryMode: 'getInventoryMode'
    })
  },

  watch: {
    getShowNotification: {
      handler(showNotification) {
        if(showNotification) {
          setTimeout(() => {
            this.setShowNotification()
          }, this.timeoutDuration)
        }
      }
    }
  }
}
</script>

<style>
  .reducedPadding {
    margin-top: -40px;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: ease;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }
</style>
